import { DatePipe, DOCUMENT, Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, QueryList, Renderer2,RendererStyleFlags2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDateService, NbDialogService, NbPopoverDirective } from '@nebular/theme';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { NgxPrintElementService } from 'ngx-print-element';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { AdmissionMasterData } from '../../../../@core/interfaces/Ip/admissionMaster';
import { DischargeTmplData } from '../../../../@core/interfaces/masters/discharge-tmpl';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { TenantBranchData } from '../../../../@core/interfaces/masters/tenantbranch';
import { UpiPaymentMst, UpiPaymentMstData } from '../../../../@core/interfaces/masters/UpiPaymentMst';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../service/date.service';
import { PrintServiceService } from '../service/print-service.service';
import { commonsettings } from '../../../../data/ezoTempSettings';
import { PhysicianData } from '../../../../@core/interfaces/masters/physician-mst';
import { SummaryData, SummaryFields, SummaryMst } from '../../../../@core/interfaces/patient-services/summary';
import * as title from '../../../../data/title.json';
import { PdfToBlobService } from '../../../../pages/pdf-to-blob.service';
import { access } from '../../../../data/access-constants';

@Component({
  selector: 'ngx-prescription-print-template',
  templateUrl: './prescription-print-template.component.html',
  styleUrls: ['./prescription-print-template.component.scss']
})
export class PrescriptionPrintTemplateComponent implements OnInit {

  @Input() prescriptiondata: Array<any>=[];
  @Input() visitDoctorDept: string;
  @Input() visitDoctor: string;
  @Input() patienttitle: string;
  @Input() language:any;
  @Input() showenglishData:boolean;
  @Input() regDetails:any;
  @Input() editData;
  @Input() templateModel:boolean;
  @Input() from:string;
  @Input() akpTemplateModel:boolean;
  @Input() bedNo: string;
  @Input() wardName: string;
  @Input() roomNo: string;
  @Input() admissionDate: string;
  @Input() vitalData: any;
  @Input() BMI: number;
  @Input() preparedBy:string;
  @Input() admissionNumber:string;
  @Input() prescribedBy:string;
  @Input() prescribedByDept:string;
  @Input() formPage:string;
  @Input() pagevisitId:any;

  taxdetails:Array<any>=[];
  saleslinedetails:Array<any>=[];
  admissionId: any;
  @Input() visitId: any;
  regId: any;

  data: any=[];
  sumMstData:any=[];
 // cetMstArray:Array<any>=[];
  p: number = 1;
  isEditComponnet: boolean = false;
  isAddComponnet: boolean = false;
  term: string;
  protected readonly unsubscribe$ = new Subject<void>();
  // private tenandId = environment.tenandId;
  // private branchId = environment.branchId;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private createdBy = localStorage.getItem("userId");

  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = false;
  detForm: FormGroup;
  fields: SummaryFields[];
  dupTitle:boolean;
 
  printCertificateTitle:boolean;
  selected: SummaryMst;

  isBtnSubmitted: boolean = false;
  printmsg:boolean =false;
  errorLabel: boolean = false;
  saveMsg:boolean=false;
  save_discharge_summary:boolean=false;
  update_discharge_summary:boolean=false;
  cancel_summary:boolean=false;
  @Input("dynamicVal") dynamic: boolean = false;
  @Input() fromMst: boolean = false;
  patDet: any;
  multiSelectFields: SummaryFields[];
  dynamicFieldsList: SummaryFields[] = [];
  templateData:any;


  srcname= !!localStorage.getItem('TenantHospitalImg')?localStorage.getItem('TenantHospitalImg'):'/assets/images/white.png';
  smallLogo:string='/assets/images/samll-logos.png'
  mombabyimage:string='/assets/images/mom-baby.jpg'
  akpDentalimage:string='/assets/images/akp-logo.jpg'
  fontStyleLists=commonsettings.font_style_lists;
  commonSettings=commonsettings.template;
  tempdecSettings=commonsettings.body

  templateForm:FormGroup;
  fontdialogForm:FormGroup;
  templatePreview:any;
  topHeaderLines: FormArray;
  bodyItemLines: FormArray;
  FooterLines: FormArray;
  commonStylechange="";

  pageTitleList:any=[];
  pageTitleSetttings:any=JSON.parse(JSON.stringify(commonsettings.template?.page_title))
  objectKeys = Object.keys;
  itemBodyList:any=[];

  docname2;
  patientid;
  patientmno;
  patientName:string;
  age:string;
  address:string;
  preDate:string

  duplicateMsg: boolean;
  erroeSavemsg: boolean;
  savedSuccessMsg: boolean;
  duplicateDischarge: boolean;
  savedSettingMsg: boolean;
  isSubmitted:boolean;
  editDischargeData:any;
  onloadeditdata:any;
  cancelDialog:boolean=false;
  onPreviewDialog:boolean=false;
  currenteditorindex;
  selectsummarymst:any;
  loadText = "Updates are in progress. Please wait";
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  totallineitemsdiscount:any;
  gstshowstatus:boolean=false;
  taxableAmount:any;
  calc1:any;
  totaltaxableAmount:number;
  calc2:any;
  gstamount:number;
  upiPaymentList: UpiPaymentMst[];
  insList: Array<any>=[];
  dissumamry1:any=[];
  dissumamry2:any=[];
  pagenumber:number=1;
  totaltaxamount:number;

  public config = {
    printMode: 'template-popup',
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'Dischrage Summary',
    // templateString: '<header>I\'m part of the template header</header>{{printBody}}<footer>I\'m part of the template footer</footer>',
    stylesheets: [{ rel: 'stylesheet', href: '/assets/css/print.css' },{ rel: 'stylesheet', href: '/assets/css/custom.css' },{ rel: 'stylesheet', href: 'https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css' },
    ],
    styles: [
    commonsettings.printCommonStyle
    ]
  };
  itemvalue:any=[];
  editorConfig: any = {
      width:'auto',
      height: 100,
      plugins:
      'print preview fullpage searchreplace autolink \
       directionality visualblocks visualchars fullscreen \
       image imagetools  media  table template codesample preview \
       charmap hr pagebreak nonbreaking anchor insertdatetime \
       advlist lists textcolor wordcount contextmenu colorpicker textpattern autoresize link image code',
      toolbar:
      'fontselect bold italic forecolor fontsizeselect strikethrough backcolor \
       alignleft aligncenter alignright alignjustify table lineheight \
       numlist bullist outdent indent preview fullscreen code  ',
      image_advtab: true,
      imagetools_toolbar:
      'rotateleft rotateright | flipv fliph | editimage imageoptions',
      toolbar_location: 'bottom',
      statusbar : false,
      toolbar_mode: 'floating',
      menubar:false,
      content_security_policy: "default-src 'self'",
      nonbreaking_force_tab: true,
      setup: function(editor) {
        editor.on('init', function(e) {
        });
      },
      init_instance_callback: function(editor) {
        editor.on('ExecCommand', function(e) {
          if("LineHeight"==e.command){
          }
        });
      }
    // superscript subscript anchor
  };
  titleList: any = (title as any).default;

  changeThemeNotifyDialog:boolean=false;
  @ViewChild('printcontent', {static: false}) printcontent: ElementRef;
  @ViewChild('downloadpdf')  downloadpdf: ElementRef;
  downloadHtml='';
  token: string;
  @Input() reviewTestList:Array<any>=[];
  buttonsDisabled:boolean=false;
  @Input() pageFrom:string;
  userAccessData: any;
   abhaField: boolean = false;
  constructor(public dateobj:DateService,protected upiPaymentSrvc: UpiPaymentMstData,
    private pdfBlobSrvc:PdfToBlobService,
    // printer settings constructor object create start by RAJA:)
    private iatchSrvc: imageatch_detData,
    protected psSrvc:PrinterSettingsData,
    public PrintServiceService:PrintServiceService,
    @Inject(DOCUMENT) public document: any,
    // printer settings constructor object create end by RAJA:)
   public datesrcv:DateService,
   private elementRef: ElementRef,
   public location:Location,public spinner:NgxSpinnerService,
   protected phySrvc: PhysicianData,protected rolesService: RolesData, public changeDetectorRef: ChangeDetectorRef, private fb: FormBuilder, private sumSrvc: SummaryData,
   private datePipe: DatePipe, protected dateService: NbDateService<Date>, private route: ActivatedRoute,public sanitizer: DomSanitizer,
   protected patRegSrvc: PatientRegistrationData, private router: Router, private renderer: Renderer2,protected tenantBrchSrvc: TenantBranchData,private dialogService: NbDialogService,public printsrvc: NgxPrintElementService,private admissionMasterService: AdmissionMasterData,protected DischargeTmplSrvc: DischargeTmplData) {
     this.detForm = this.generateForm();
     this.token = this.route.snapshot.queryParams['tokenNumber'];
     this.route.params.subscribe(params => {
          this.regId       = params['regId'];
          this.admissionId = params['admissionId'];
      });
      this.fontdialogForm = this.fb.group({
        elementVal: this.fb.control(null),
        fontfamily: this.fb.control(this.commonSettings?.fontfamily),
        fontColor: this.fb.control('#333333'),
        fontSize: this.fb.control(12),
        isBold: this.fb.control(false),
        isItalic: this.fb.control(false),
        isUnderline: this.fb.control(false),
        linespace: this.fb.control(1),
        textAlign: this.fb.control("left"),
        outdent: this.fb.control(0),
        indent: this.fb.control(0),
        textheight: this.fb.control(1)
      });
      this.templateForm = this.fb.group({
        //Template prop
        templatename: this.fb.control(null,[Validators.required,],),
        tmplCommonFlag:this.fb.control(null),
        tmplReportHeader:this.fb.control(null),
        tmplReportFooter:this.fb.control("Header"),
        tmplDisplayDept:this.fb.control("Footer"),
        tmplDisplayPhy:this.fb.control(null),
        tmplDisplaySettings:this.fb.control(null),
        tmplActiveFlag:this.fb.control(null),
        ps:this.fb.control('A4',[Validators.required,],),
        orientation:this.fb.control('Portrait',[Validators.required,],),
        lm:this.fb.control(10,[Validators.required],),
        rm:this.fb.control(10,[Validators.required],),
        tm:this.fb.control(10,[Validators.required],),
        bm:this.fb.control(10,[Validators.required],),
        id: this.fb.control(null),
        height: this.fb.control(null),
        width: this.fb.control(null),
        bgColor: this.fb.control('#ffffff'),
        labelColor: this.fb.control('#333333'),
        fontColor: this.fb.control('#333333'),
        fontSize: this.fb.control(12),
        fontfamily: this.fb.control(this.commonSettings?.fontfamily),
        imagewidth: this.fb.control(60),
        temptype: this.fb.control(null),
        //Header
        topHeaderRequired: this.fb.control(true),
        topHeaderLogoRequired: this.fb.control(true),
        topHeaderLogoPosition: this.fb.control('center start'),
        topHeaderPosition: this.fb.control('center end'),
        topHeaderheight: this.fb.control(60),
        topHeaderlineheight: this.fb.control(18),
        topHeaderLines: new FormArray([]),
        topheaderbgColor: this.fb.control('#ffffff'),
        topheaderfontColor: this.fb.control('#333333'),
        topheaderfontfamily: this.fb.control(this.commonSettings?.fontfamily),
        pageTitle: this.fb.control('Discharge Summary'),
        pageTitlefontsize: this.fb.control(14),
        reportHeaderPlacement: this.fb.control('center center'),
        pageTitleHeaderRequired: this.fb.control(true),
        //
        pageTitleData: this.fb.control(true),
        // Body Table
        bodyItemLines: new FormArray([]),
        bodyHeader:this.fb.group({
          itemname: this.fb.control(1),
          itemvalue: this.fb.control(null),
          itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
          itemfontcolor: this.fb.control(this.commonSettings.fontColor),
          itemfontsize: this.fb.control(this.commonSettings.fontSize),
          itemisdisplay: this.fb.control(true),
          itemposition: this.fb.control('Left'),
          itemismandatory: this.fb.control(false),
          itemtype: this.fb.control('Body'),
        }),
        bodyValue:this.fb.group({
          itemname: this.fb.control(1),
          itemvalue: this.fb.control(null),
          itemfontfamily: this.fb.control(this.commonSettings.fontfamily),
          itemfontcolor: this.fb.control(this.commonSettings.fontColor),
          itemfontsize: this.fb.control(12),
          itemisdisplay: this.fb.control(true),
          itemposition: this.fb.control('Left'),
          itemismandatory: this.fb.control(false),
          itemtype: this.fb.control('Body'),
        }),

        tblrow: this.fb.control(1),
        tblcol: this.fb.control(1),
        bodylayout: this.fb.control('Top Bottom'),
        //Footer
        FooterRequired: this.fb.control(null),
        FooterLogoRequired: this.fb.control(null),
        FooterLogoPosition: this.fb.control(null),
        FooterPosition: this.fb.control(null),
        Footerheight: this.fb.control(60),
        Footerlineheight: this.fb.control(18),
        FooterLines: new FormArray([]),
        FooterbgColor: this.fb.control('#ffffff'),
        FooterfontColor: this.fb.control('#333333'),
        Footerfontfamily: this.fb.control(this.commonSettings?.fontfamily),
        bottomDocsignrequired: this.fb.control(null),
        bottomDocsignPosition: this.fb.control('center end'),
        bottomDocsignLabel: this.fb.control('Dr Name'),
        bottomDocsignLabelsize: this.fb.control(12),
        bottomDocsignimg: this.fb.control(null),
        bottomDocsignftcol: this.fb.control('#000000'),

        FooterLine1: this.fb.control(null),
        FooterLine2: this.fb.control(null),
        FooterLine3: this.fb.control(null),
        FooterLine4: this.fb.control(null),
        reportHeader: this.fb.control(null),
        reportFooter: this.fb.control(null),
       });
     this.fontdialogForm.valueChanges.subscribe(data => this.onFontDialogValueChanged(data));
   }

  ngOnInit(): void {
    this.loadPSF()
    this.loadImg()
    this.fetchPageAccess()
  }
  pageName:any
  psDetails:any
  billVisibleOption:any
  styleUrl:any
  tenantId:any
  pagename2:any
  loadPSF()
  {
    // call api load printer settings
    this.psSrvc.list(this.tenandId +"/"+this.branchId+ "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var ps=data.filter(ps=>ps.pageSetupFor==this.pageName)
      // set printer settings data
      if(ps.length>0){
        this.psDetails=ps[0];
        if(!!this.psDetails?.othersettings)
          this.billVisibleOption=this.PrintServiceService.setVisibleHideOption(JSON.parse(this.psDetails.othersettings));
        else
          this.billVisibleOption=this.PrintServiceService.getPrinterVisibleData("opbill");

          // dynamic set style url based on papper size
          this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
          // set header and footer position & required
          this.psDetails=this.PrintServiceService.onSetPsData(this.psDetails);
          this.config=this.PrintServiceService.printConfig(this.psDetails)

          if(this.tenantId==this.PrintServiceService.bloomTID && this.branchId==this.PrintServiceService.bloomBID){
            this.pagename2="Out-Patient Cash Bill/Receipt";
            this.pagename2=this.pagename2.toUpperCase();
          }
          // end
      }else{
          this.psDetails=this.PrintServiceService.onGetPrinterSettings();
          this.config=this.PrintServiceService.printConfig(this.psDetails)
      }

      }, (error) => {
      }, () => {
      });

  }

  // load tenant img  ***********  Raja
  loadImg(){
    this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var x =  data.filter(x=>x.phyId==null&&x.empId==null&&x.patId==null&&x.tenantId===this.tenandId)
      this.srcname="../.././../../assets/images/logo.png";
      if(x.length>0)
      {
        x[0].isCreate = true;
        x[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenandId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
        this.srcname = 'data:image/jpeg;base64,' + downloaddata;
        }, (error) => {
        }, () => {
        });
      }
    }, (error) => {
    }, () => {
  });
}


  ngOnChanges(changes: any): void {
    if(this.prescriptiondata!=null && this.regDetails!=null && this.editData!=null){
      this.templateData=this.editData;
      this.translatedata();
    }
  }

  openExistingSummary(){
    this.closeTemplateDialog();
    this.router.navigate([`/pages/ip/new-dashboard/${this.regId}/${this.admissionId}`], { queryParams: { pageName:'DischargeSummary' } });
  }
  changeTemplate(){
    this.changeThemeNotifyDialog=true;
  }
  closeTemplateDialog(){
    this.changeThemeNotifyDialog=false;
    this.changeThemeNotifyDialog=false;
  }
  chnageTemplateOK(){
    this.detForm.controls['fieldsSelect'].enable();
    this.detForm.enable();
    this.changeThemeNotifyDialog=false;
  }
  get fval():{[key: string]: AbstractControl} { return this.templateForm.controls; }
  get fval1():{[key: string]: AbstractControl} { return this.fontdialogForm.controls; }
  get apiUrl() {   return environment.baseUrl;  }

  generateForm(): FormGroup {
    const baseForm = this.fb.group({});
    baseForm.addControl("fieldsSelect", new FormControl(null));
    baseForm.addControl("sumType", new FormControl(null));
    baseForm.addControl("title", new FormControl(null, [Validators.maxLength(50)]));
    this.sumSrvc.list(`${this.apiUrl}/patSum/${this.tenandId}/${this.branchId}/fields`).pipe(takeUntil(this.unsubscribe$)).subscribe(data => {

      this.fields =data;
      this.multiSelectFields = this.fields.filter(t => t.tblName && t.tblName.toLocaleLowerCase().indexOf("patientregistration") > -1);
      this.fields.forEach(y => {
        baseForm.addControl(y.fieldName, new FormControl(null));
      });
      this.detForm = baseForm;
      return baseForm;
    }, (error) => {
      this.detForm = baseForm;
      return baseForm;
    }, () => {
      this.fetchPatDetails();
    }
    );
    return baseForm;
  }
  fetchPatDetails(): void {
    if (this.regId !== null && this.regId !== undefined) {
      this.patRegSrvc.getById("patientregistrationmst/" + this.tenandId + '/' + this.branchId + '/' + this.regId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.patDet = data;
        this.patDet.dob = this.datePipe.transform(data.dob, 'mediumDate');
        this.multiSelectFields.forEach(det => {
          if (this.patDet[det.columnName] != null && this.patDet[det.columnName] != undefined)
            this.detForm.controls[det.fieldName].setValue(this.patDet[det.columnName]);
        });
      }, (error) => {

      }, () => {
       

      });
    }
    else
      return;
  }
  fetchPageAccess() {
       
        const matrixSearchData = {
          taskId: [access.task.ABHAPRES],
          UserId: localStorage.getItem('userType')
        };
        this.rolesService.create(`${this.apiUrl}/userrole/${this.tenandId}/${this.branchId}/pageaccesssearch`, matrixSearchData)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((data: any) => {
            this.userAccessData = data;
          }, () => {}, () => {
            this.abhaField = this.checkAccess(access.task.ABHAPRES);
          });
      }
     checkAccess(taskId: any): boolean {
      return this.userAccessData?.some(element =>
        taskId == element.taskID &&
        element.actionID == access.action.VIEW &&
        element.permission == "true"
      );
    }
  ngOnDestroy(): void {
    this.itemvalue=this.itemvalue?.map((x,index)=>{
      x.displayeditor=false;
      x.displaytext=false;
      return {...x}
    })
  }
  onChange(args: any[] ) {
    this.selectsummarymst=args;

    this.templateData=this.selectsummarymst[0]?.data;
    this.editdata(args[0]?.data);
    this.editDischargeData=null;

  }

  translatedata(){
    let transferedtakenatdata;
    transferedtakenatdata = this.prescriptiondata.map((prescription) => {
      return {
        text: !prescription.takenAt?'':prescription.takenAt,
      }
    });
    if(!!transferedtakenatdata){
      this.rolesService.create(this.apiUrl + "/multilanguage/transfer/" + this.language.toString(), transferedtakenatdata).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        let translateData=JSON.parse(data);
        for(var i=0;i<this.prescriptiondata.length;i++) {
          for(var j=0;j<translateData.length;j++) {
            if(i==j){
              this.prescriptiondata[i].takenAtinotherlang=translateData[j].translations[0].text;
            }
          }
        }
        }, (error) => {
        }, () => {
          this.editdata(this.editData);
        });
      }
  }
  async editdata(data){
    this.pagenumber =1;
    this.templateForm.controls['templatename'].setValue(data?.tmplName);
    this.templateForm.controls['tmplCommonFlag'].setValue(data?.tmplCommonFlag=='Y'?true:false);
    this.templateForm.controls['tmplReportHeader'].setValue(data?.tmplReportHeader);
    this.templateForm.controls['tmplReportFooter'].setValue(data?.tmplReportFooter);
    this.templateForm.controls['tmplDisplayDept'].setValue(data?.tmplDisplayDept=='Y'?true:false);
    this.templateForm.controls['tmplDisplayPhy'].setValue(data?.tmplDisplayPhy=='Y'?true:false);
    this.templateForm.controls['tmplDisplaySettings'].setValue(JSON.parse(data?.tmplDisplaySettings));
    this.templateForm.controls['tmplActiveFlag'].setValue(data?.tmplActiveFlag=='Y'?true:false);
    var template={...JSON.parse(data?.tmplDisplaySettings),
      temp_title:JSON.parse(data?.tempTitle),
      page_title:JSON.parse(data?.pageTitle),
      footer:JSON.parse(data?.footer)}
    this.templateForm.controls['bgColor'].setValue(template?.bgColor);
    this.templateForm.controls['imagewidth'].setValue(template?.imagewidth);
    this.templateForm.controls['ps'].setValue(template?.ps);
    this.templateForm.controls['orientation'].setValue(template?.orientation);
    this.templateForm.controls['tm'].setValue(template?.tm);
    this.templateForm.controls['bm'].setValue(template?.bm);
    this.templateForm.controls['lm'].setValue(template?.lm);
    this.templateForm.controls['rm'].setValue(template?.rm);
    this.templateForm.controls['labelColor'].setValue(template?.labelColor);
    this.templateForm.controls['fontSize'].setValue(template?.fontSize);
    this.templateForm.controls['fontfamily'].setValue(template?.fontfamily);
    this.templateForm.controls['bodylayout'].setValue(template?.bodylayout);
    this.templateForm.controls['temptype'].setValue(template?.temptype);

    this.pageTitleSetttings=template?.page_title,
    this.pageTitleList=template?.page_title?.fields;
    this.pageTitleList=this.pageTitleList?.map(x=>{
      if(x.new!="new" || !!x.value)
        x.value=this.replaceVariableTostring(x.value);
      return {...x}
    });

    (this.templateForm.get('bodyItemLines') as FormArray).clear();
    this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
    var bodyitmes=data?.dischargeTmplDet;


    this.itemvalue=[];
    bodyitmes?.filter(async (x,index)=>{
      var headerjson={
        "itemfontfamily":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontfamily,
        "itemfontcolor":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontColor,
        "itemfontsize":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontSize,
        "itemposition":JSON.parse(x.rowSettings)?.header?.fontstyle?.textAlign,
      }
      var valuejson={
        "itemfontfamily":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontfamily,
        "itemfontcolor":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontColor,
        "itemfontsize":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontSize,
        "itemposition":JSON.parse(x.rowSettings)?.value?.fontstyle?.textAlign,
      }

      var pagecount;
      if(template?.temp_title?.rowCount != null && template?.temp_title?.rowCount != ""){
        pagecount=Number(template.temp_title.rowCount)
      }else{
        pagecount= 10;
      }
      var count=pagecount;
      var pagebreaks="<p style='page-break-after:always;'></p>";
      var footerpagenumber="<footer>{pagenumber} To be Continued</footer>";

 if (x.rowId == 1) {
  var disSummary, dissummary2, headerindex, tableindexstart, footerindex;

  var rowDefaultValue = x.rowDefaultValue;
  if (!!rowDefaultValue && (rowDefaultValue.includes('id="reviewTest"') || rowDefaultValue.includes("id='reviewTest'"))) {
    rowDefaultValue = this.replaceReviewTest(rowDefaultValue);
  }

  headerindex     = rowDefaultValue.indexOf("<tbody>");
  tableindexstart = rowDefaultValue.indexOf("<tr id=");
  footerindex     = rowDefaultValue.indexOf("</tbody>");

  disSummary  = this.sliceval(rowDefaultValue, 0, headerindex + 7);
  dissummary2 = this.sliceval(rowDefaultValue, footerindex, rowDefaultValue.length);

  this.dissumamry1 = [];
  this.dissumamry2 = [];
  count = pagecount;
  var finalsummary, lastonw;

  // ---- build one medicine row ----
  const buildLineItem = (k: number): string => {
    let rowHtml = this.replacelineitems(this.sliceval(rowDefaultValue, tableindexstart, footerindex), k);

    const rec = this.prescriptiondata[k];

    const freq = rec?.frequency;
    const hasFreq = !!freq && String(freq).trim() !== '' && String(freq).trim().toLowerCase() !== 'null';

    const hasTiming =
      [rec?.mor, rec?.aft, rec?.eve, rec?.night]
        .some(v => v !== null && v !== undefined && String(v).trim() !== '' && String(v).trim().toLowerCase() !== 'null');

    // MERGE only when frequency text exists AND there are no timing values
    if (hasFreq && !hasTiming) {
      rowHtml = rowHtml.replace(
        /<td id="intaken"[^>]*>[\s\S]*?<\/td>\s*<td id="intaken"[^>]*>[\s\S]*?<\/td>\s*<td id="intaken"[^>]*>[\s\S]*?<\/td>\s*<td id="intaken"[^>]*>[\s\S]*?<\/td>/,
        '<td colspan="4" style="border: 1px solid #4a7c9e; padding: 14px 8px; text-align: center; font-size: 15px;">' + String(freq).trim() + '</td>'
      );
    }
    // else: keep the 4 separate timing cells (1 | 1 | 0 | 1)

    return rowHtml;
  };

  for (var k = 0; k < this.prescriptiondata.length; k++) {

    if (k + 1 == count) {
      this.dissumamry1 = this.dissumamry1 + buildLineItem(k);
      finalsummary = disSummary.concat(this.dissumamry1.toString());
      lastonw = finalsummary.concat(dissummary2.toString());

      if (this.dissumamry2 == "") {
        this.dissumamry2 = lastonw + this.replacepagenumber(footerpagenumber, 0);
        this.pagenumber += 1;
      }
      else {
        this.dissumamry2 = this.dissumamry2 + pagebreaks + lastonw + this.replacepagenumber(footerpagenumber, 0);
        this.pagenumber += 1;
      }
      this.dissumamry1 = [];
      count += pagecount;
    }
    else if (k + 1 == this.prescriptiondata.length) {
      this.dissumamry1 = this.dissumamry1 + buildLineItem(k);
      finalsummary = disSummary.concat(this.dissumamry1.toString());
      lastonw = finalsummary.concat(dissummary2.toString());
      if (this.dissumamry2 == "") {
        this.dissumamry2 = lastonw;
      }
      else {
        this.dissumamry2 = this.dissumamry2 + pagebreaks + lastonw;
      }
      this.dissumamry1 = [];
    }
    else {
      if (this.dissumamry1.length == 0) {
        this.dissumamry1 = buildLineItem(k);
      }
      else {
        this.dissumamry1 = this.dissumamry1 + buildLineItem(k);
      }
    }
  }

  this.itemvalue.push({ value: this.dissumamry2, displayeditor: false, displaytext: true });
  var headername = !!x?.rowHeader ? x?.rowHeader : x?.rowHeaderName;
  this.bodyItemLines.push(this.fb.group({
    header: { itemvalue: headername, ...JSON.parse(x.rowSettings).header, ...headerjson },
    value:  { itemvalue: this.dissumamry2, ...JSON.parse(x.rowSettings).value, ...valuejson }
  }));
}
else if(x.rowId==2){
            var disSummary= x.rowDefaultValue;
            disSummary=this.replaceVariableTostring(disSummary);
            this.itemvalue.push({value:disSummary,displayeditor:false,displaytext:true});
            var headername=!!x?.rowHeader?x?.rowHeader:x?.rowHeaderName
            this.bodyItemLines.push(this.fb.group({
              header:{itemvalue:headername,...JSON.parse(x.rowSettings).header,...headerjson},
              value: {itemvalue:disSummary,...JSON.parse(x.rowSettings).value,...valuejson}
            }));
      }

    });
    this.itemBodyList=[...this.bodyItemLines.value.map((x,index)=>{
      return {
        index:index,...x
      }
    })];
    (this.templateForm.get('topHeaderLines') as FormArray).clear();
     const addressDetail = data?.branchWiseAddressDetail;
        
            if (!addressDetail || Object.keys(addressDetail).length === 0) {
              this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
              this.topHeaderLines.clear();
            
              template?.temp_title?.topHeaderLines
                ?.filter(x => !!x.name)
                .forEach(x => {
                  this.topHeaderLines.push(this.fb.group({
                    name: x.name,
                    value: x.value,
                    fontsize: x.fontsize
                  }));
                });
            
              this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
              this.FooterLines.clear();
            
              template?.footer?.bottomLines
                ?.filter(x => !!x.name)
                .forEach(x => {
                  this.FooterLines.push(this.fb.group({
                    name: x.name,
                    value: x.value,
                    fontsize: x.fontsize
                  }));
                });
            } else {
              this.topHeaderLines = this.templateForm.get('topHeaderLines') as FormArray;
              this.topHeaderLines.clear();
            
              const headerLines = JSON.parse(addressDetail.templateHeaderConfig || '[]');
              headerLines.forEach((line: any) => {
                this.topHeaderLines.push(this.fb.group({
                  name: line.name,
                  value: line.value,
                  fontsize: line.fontsize
                }));
              });
            
              this.FooterLines = this.templateForm.get('FooterLines') as FormArray;
              this.FooterLines.clear();
            
              const footerLines = JSON.parse(addressDetail.templateFooterConfig || '[]');
              footerLines.forEach((line: any) => {
                this.FooterLines.push(this.fb.group({
                  name: line.name,
                  value: line.value,
                  fontsize: line.fontsize
                }));
              });
            }
            if(!!template?.temp_title){
              delete template?.temp_title['topHeaderLines']
              for(let x of this.objectKeys(template?.temp_title)){  
                try{
                  if(!!this.templateForm.controls[x])
                    this.templateForm.controls[x].setValue(template?.temp_title[x])
                }catch(Execption){}
              }
            }
    if(!!template?.footer){
      delete template?.footer['bottomLines']
      for(let x of this.objectKeys(template?.footer)){
        try{
          if(!!this.templateForm.controls[x])
            this.templateForm.controls[x].setValue(template?.footer[x])
        }catch(Execption){}
      }
    }
    this.onPreview();
  }

  replaceReviewTest(html) {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const section = doc.getElementById('reviewTest');
    if (!section) return html;

    const template = doc.getElementById('review');
    if (!template) return html;
  
    const rowTemplate = template.innerHTML;
    const reviewTestList = this.reviewTestList || [];

    if (!reviewTestList.length) {
      section.remove();
      return new XMLSerializer().serializeToString(doc.documentElement);
    }
  
    let finalRows = '';
  let index=1;
  reviewTestList.forEach((item) => {
  
      let row = rowTemplate;
      
      row = row
      .replace((new RegExp("{id}", "g")),(index++).toString())
      .replace((new RegExp("{service}", "g")),item?.servicename)
      .replace((new RegExp("{notes}", "g")),item?.notes ? '( '+item?.notes+' )' : '')
        
      finalRows += `<div>${row}</div>`;
    });
  
    // Insert rows after template
    template.insertAdjacentHTML('afterend', finalRows);
  
    // Remove template
    template.remove();
  
    return new XMLSerializer().serializeToString(doc.documentElement);
  

  }

  onprint(){
    this.templatePreview=this.templateForm.value;
  }
  setformtewoValue(control,val){
    this.fontdialogForm.controls[`${control}`].setValue(val);
  }
  async onPreview(){
    this.templatePreview=this.templateForm.value;
    this.config.styles.push(`@media print {
              @page
              {
                margin-top: ${this.templatePreview?.tm}px !important;
              }
            }
    `);

    await this.sleep(1000)
    this.pageTitleList.filter(async (x,index)=>{
      var headerval={...x.headerstyle,elementVal:null};
      var headerelem=document.getElementById("pageheaderhead"+index) as HTMLElement;
      if(!!headerelem){
        headerval.elementVal=headerelem;
        this.onFontDialogValueChanged(headerval);
      }
      var bodyval={...x.valuestyle,elementVal:null};
      var bodyelem=document.getElementById("pageheadervalue"+index) as HTMLElement;
      if(!!bodyelem){
        bodyval.elementVal=bodyelem;
        this.onFontDialogValueChanged(bodyval);
      }
    });
    this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
       var headerval={...x.header.fontstyle,elementVal:null};
       var headerelm=document.getElementById("itembodyheader"+index) as HTMLElement;
       if(!!headerelm){
          headerval.elementVal=headerelm;
          this.onFontDialogValueChanged(headerval);
       }
       var bodyval={...x.value.fontstyle,elementVal:null};
       var bodyelem=document.getElementById("itembodyvalue"+index) as HTMLElement;
       if(!!bodyelem){
          bodyval.elementVal=bodyelem;
          this.onFontDialogValueChanged(bodyval);
       }
    });
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
onFontDialogValueChanged(data){
     if(!!data && !!data.elementVal)
        this.setfontstyle(data);
     if(!!this.commonStylechange){
      this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
        if(this.commonStylechange=="header"){
          var headerval=this.fontdialogForm.value;
          headerval.elementVal=document.getElementById("itembodyheader"+index) as HTMLElement;
          this.setfontstyle(headerval);
        }
        if(this.commonStylechange=="value"){
          var bodyval=this.fontdialogForm.value;
          bodyval.elementVal=document.getElementById("itembodyvalue"+index) as HTMLElement;
          this.setfontstyle(bodyval);
        }
     });
    }
  }
  setfontstyle(data){
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    this.renderer.setStyle(data?.elementVal, 'color', data?.fontColor,flags);
    this.renderer.setStyle(data?.elementVal, 'font-size', data?.fontSize+'pt',flags);
    this.renderer.setStyle(data?.elementVal, 'font-family', data?.fontfamily,flags);
    this.renderer.setStyle(data?.elementVal, 'font-weight', data?.isBold?'bold':'normal',flags);
    this.renderer.setStyle(data?.elementVal, 'font-style', data?.isItalic?'italic':'normal',flags);
    this.renderer.setStyle(data?.elementVal, 'text-decoration', data?.isUnderline?'underline':'none',flags);
    this.renderer.setStyle(data?.elementVal, 'text-align', data?.textAlign,flags);
    this.renderer.setStyle(data?.elementVal, 'line-height', data?.textheight,flags);
    this.renderer.setStyle(data?.elementVal, 'padding-left', data?.indent+"px",flags);
  }
   fontdialog(event,commonStylechange?){
    if(!!commonStylechange)
      this.commonStylechange=commonStylechange;
    else
      this.commonStylechange=null;
    var existdata=JSON.parse(JSON.stringify(event?.style));
    var res=existdata?.color.replace("rgb",'').replace("(",'').replace(')','').split(",").map(Number);

    this.fontdialogForm.setValue({
          "elementVal": event,
          "fontfamily": this.commonSettings.fontfamily,
          "fontColor": rgbToHex(res[0],res[1], res[2]),
          "fontSize": parseInt(existdata?.fontSize.split("pt")[0]),
          "isBold": !!existdata?.fontWeight ? existdata?.fontWeight=="bold"?true:false : false,
          "isItalic": !!existdata?.fontStyle ? existdata?.fontStyle=="italic"?true:false : false,
          "isUnderline": !!existdata?.textDecoration ? existdata?.textDecoration=="underline"?true:false : false,
          "linespace":  !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
          "textAlign": !!existdata?.textAlign ? existdata?.textAlign : "left",
          "outdent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])):'0',
          "indent": !!existdata.paddingLeft ? (parseInt(existdata.paddingLeft.split("px")[0])) :'0',
          "textheight": !!existdata?.lineHeight ? parseFloat(existdata?.lineHeight) : 1,
     });
     var returndata=this.fontdialogForm.value;
     delete returndata['elementVal'];
     return returndata;
   }
   setpragraph(type,value){
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    var data_=this.fontdialogForm.controls['elementVal'].value;
    var existdata=JSON.parse(JSON.stringify(data_?.style));
    var margindata=0;
    if(type=="indent"){
      margindata=5;
      if(existdata.paddingLeft!="")
        margindata=(parseInt(existdata.paddingLeft.split("px")[0])+5)
        this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags);
    }
    else if(type=="outdent"){
      margindata=parseInt(existdata.paddingLeft.split("px")[0]);
      if(margindata>=0)
        margindata=margindata-5;
      else
        margindata=margindata-5;
        this.renderer.setStyle(this.fval1?.elementVal.value, 'padding-left', margindata+"px",flags);
    }
    if(!!this.commonStylechange)
      this.fontdialogForm.controls['indent'].setValue(margindata);
  }
  checkpageTitleVisible(){
    var data=this.pageTitleList?.find(x=>x.display==true)
    if(!!data)
      return true;
    else
      return false;
  }

    getPatientAgeByYear(dob,ageResult,dobFlag): any{

    if(dobFlag=="Y"){
    
       var patientDob=new Date(dob);
    
       var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
         ageValue= Math.trunc(ageValue);
          
      return ageValue+' Y '
    
    }else{
    
    
      if(ageResult!=null){
    
      var patientAgeResult=new Date(ageResult);
    
      var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
       ageValue= Math.trunc(ageValue); //Get Before Decimal Value
    return ageValue+' Y '
    }else{
      return '-'
    
    }
    } 
   }

  getPatientAgeByDOB(dob,ageResult,dobFlag): any{

    if(dobFlag=="Y"){

       var patientDob=new Date(dob);

       var Difference_In_Time = Math.abs(Date.now() - patientDob.getTime());
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        var ageValue = Difference_In_Days / 365.25;
         ageValue= Math.trunc(ageValue);
        //extract the year, month, and date from user date input
       // var dobYear = patientDob.getFullYear();
        var dobMonth = patientDob.getMonth();
        var dobDate = patientDob.getDate();

        //get the current date from the system
        var now = new Date();
        //extract the year, month, and date from current date
        var currentMonth = now.getMonth();
        var currentDate = now.getDate();

        //get months
        if (currentMonth >= dobMonth)
          //get months when current month is greater
          var monthAge = currentMonth - dobMonth;
        else {
         // yearAge--;
          var monthAge = 12 + currentMonth - dobMonth;
        }

        //get days
        if (currentDate >= dobDate)
          //get days when the current date is greater
          var dateAge = currentDate - dobDate;
        else {
          monthAge--;
          var dateAge = 31 + currentDate - dobDate;

          if (monthAge < 0) {
            monthAge = 11;
          //  yearAge--;
          }
        }
    return ageValue+' Y '+monthAge+' M '+dateAge+' D'

    }else{


      if(ageResult!=null){

      var patientAgeResult=new Date(ageResult);

      var Difference_In_Time = Math.abs(Date.now() - patientAgeResult.getTime());
      var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
      var ageValue = Difference_In_Days / 365.25;
       ageValue= Math.trunc(ageValue); //Get Before Decimal Value

        //extract the year, month, and date from user date input
        var dobYear = patientAgeResult.getFullYear();
        var dobMonth = patientAgeResult.getMonth();
        var dobDate = patientAgeResult.getDate();

        //get the current date from the system
        var now = new Date();
        //extract the year, month, and date from current date
        var currentMonth = now.getMonth();
        var currentDate = now.getDate();

        //get months
        if (currentMonth >= dobMonth)
          //get months when current month is greater
          var monthAge = currentMonth - dobMonth;
        else {
         // yearAge--;
          var monthAge = 12 + currentMonth - dobMonth;
        }

        //get days
        if (currentDate >= dobDate)
          //get days when the current date is greater
          var dateAge = currentDate - dobDate;
        else {
          monthAge--;
          var dateAge = 31 + currentDate - dobDate;

          if (monthAge < 0) {
            monthAge = 11;
          //  yearAge--;
          }
        }
    return ageValue+' Y '+monthAge+' M '+dateAge+' D'
    }else{
      return '-'

    }
    }
   }
   valueChange(value,event,index){
      this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
      var val=this.bodyItemLines.controls[index].value;
      val.value.itemvalue=value
      this.bodyItemLines.controls[index].setValue(val);
   }
   getDistempl(){

   }
   savePatientDischargeTemp(event:any): void {
    this.onPreview();
     event.target.disabled=true;
     this.isSubmitted = true;
     this.isBtnSubmitted = true;
     var trimedval=(this.templateForm.get('templatename').value).replace(/\s+/g, ' ').trim();
     var setings=this.jsontodb(this.commonSettings,this.templateForm.value);
     var tempSettings=JSON.parse(JSON.stringify(setings));
     if (this.templateForm.valid && trimedval!="") {
      this.spinner.show();
      var tempdetails=JSON.parse(JSON.stringify(tempSettings));
      delete tempSettings['temp_title'];
      delete tempSettings['footer'];
      delete tempSettings['page_title'];

       var newDischargeTmplData = {
        regId:this.regId,
        admissionId:this.admissionId,
        templateId:this.templateData.id,
        templateName:this.templateForm.get("templatename").value,
        displayDepartment:null,
        displayPhysician:null,
        dischargeSummaryStatus:null,
        dischargeSummaryDeliveryStatus:null,
        dischargeSummaryDeliveryDate:new Date(),
        dischargeSummaryDeliveryMode:null,
        dischargeSummaryReceiverDetail:null,
        dischargeSummaryReceiverFeedback:null,
        reportHeader:null,
        reportFooter:null,
        footer:JSON.stringify(tempdetails.footer),
        displaySettings:JSON.stringify(tempSettings),
        temptitle:JSON.stringify(tempdetails.temp_title),
        pagetitle:JSON.stringify(tempdetails.page_title),
        tenantId:this.tenandId,
        branchId:this.branchId,
        createdDate:new Date(),
        createdBy:parseInt(this.createdBy),
        updatedDate:null,
        updatedBy:null,
        updatedIP:null,
        createdIP:null,
        dischargeTemplateTransDet:[],
       };
       newDischargeTmplData.dischargeTemplateTransDet=[];
       newDischargeTmplData.dischargeTemplateTransDet=this.templatePreview.bodyItemLines?.map((x,index)=>{
            var data= {
              "tmplId": this.templateData?.id,
              "rowId": index+1,
              "id":!!this.editDischargeData?this.editDischargeData?.details[index]?.id:null,
              "rowHeader": x.header.itemvalue,
              "rowDefaultValue": this.itemvalue[index].value,
              "rowSettings": JSON.stringify(this.itemtblsettings(x,index)),
              "displayPosition":!!this.editDischargeData?this.editDischargeData?.details[index]?.displayPosition:null,
              "tempTransMstId":!!this.editDischargeData?this.editDischargeData?.details[index]?.tempTransMstId:null,
              "tenantId": this.tenandId,
              "branchId":this.branchId
          }
          if(!!!this.editDischargeData){
            delete data['id'];
            delete data['tempTransMstId'];
          }
          return data;
         }
       );

      if(!!!this.editDischargeData){
       this.DischargeTmplSrvc.create("PatientDischargeTmpl/" + this.tenandId+"/"+this.branchId+"/saveDischargeTemplate", newDischargeTmplData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
              this.save_discharge_summary = true;
              setTimeout(() => {
                this.save_discharge_summary = false;
              }, 2000);
          this.spinner.hide();
       }, (error) => {
          this.spinner.hide();
         event.target.disabled=false;
         this.isSubmitted = false;
         this.isBtnSubmitted = false;
          this.erroeSavemsg = true;
          setTimeout(() => {
            this.erroeSavemsg = false;
          }, 4000);
       }, () => {
          event.target.disabled=false;
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.onChange(this.selectsummarymst)
          this.spinner.hide();
        });
       }
       else{
        newDischargeTmplData["id"]=this.editDischargeData?.header?.id;
        newDischargeTmplData.createdBy=this.editDischargeData?.header?.createdBy;
        newDischargeTmplData.createdDate=this.editDischargeData?.header?.createdDate;
        newDischargeTmplData.updatedBy=parseInt(this.createdBy);
        newDischargeTmplData.updatedDate=new Date();
        this.DischargeTmplSrvc.update(this.apiUrl+"/PatientDischargeTmpl/" + this.tenandId +"/"+this.branchId+"/"+this.editDischargeData?.header?.id+"/update", newDischargeTmplData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.spinner.hide();
            this.update_discharge_summary = true;
            setTimeout(() => {
              this.update_discharge_summary = false;
            }, 2000);
        }, (error) => {
          this.spinner.hide();
          event.target.disabled=false;
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.erroeSavemsg = true;
          setTimeout(() => {
            this.erroeSavemsg = false;
          }, 4000);
        }, () => {
          event.target.disabled=false;
          this.isSubmitted = false;
          this.isBtnSubmitted = false;
          this.onChange(this.selectsummarymst)
           });
          this.spinner.hide();
         }
     }
     else
     {
        this.spinner.hide();
        this.templateForm.controls['templatename'].markAsDirty();
        event.target.disabled=false;
        this.isBtnSubmitted = false;
       return;
     }
   }
   open_confirmation_popup(){
      this.cancelDialog=true;
   }
   close_confirmation_popup(){
      this.cancelDialog=true;
   }
   deleteDischargeSummary(){
      this.DischargeTmplSrvc.delete(`${this.apiUrl}/dischargeTmpl/${this.tenandId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      }, (error) => {
      }, () => {
      });
   }

   itemtblsettings(data,index){
    var res=data;
    res.header.fontstyle=this.fontdialog(document.getElementById("itembodyheader"+index) as HTMLElement)
    res.value.fontstyle=this.fontdialog(document.getElementById("itembodyvalue"+index) as HTMLElement)
    delete res.header['itemfontsize']
    delete res.header['itemfontfamily']
    delete res.header['itemfontcolor']
    delete res.header['itemposition']

    delete res.value['itemfontsize']
    delete res.value['itemfontfamily']
    delete res.value['itemfontcolor']
    delete res.value['itemposition']

    delete res.header['itemvalue']
    delete res.value['itemvalue']
    return res;
   }

   jsontodb(json,values){
     var  template={
      temp_title:{
        topHeaderLogoPosition: "center start",
        topHeaderLogoRequired: true,
        topHeaderPosition: "center end",
        topHeaderRequired: true,
        topHeaderheight: 60,
        topHeaderlineheight: 18,
        topheaderbgColor: null,
        topheaderfontColor: "#333333",
        topheaderfontfamily: null,
        pageTitle: null,
        pageTitleHeaderRequired: true,
        pageTitlefontsize: 14,
        topHeaderLines:[]
        },
      page_title:this.pageTitleSetttings,
      footer:{
            FooterLogoPosition: "center start",
            FooterLogoRequired: false,
            FooterPosition: "center end",
            FooterRequired: false,
            FooterbgColor: null,
            FooterfontColor: "#333333",
            Footerfontfamily: null,
            Footerheight: 60,
            Footerlineheight: 18,
            bottomDocsignLabel: "",
            bottomDocsignLabelsize: 12,
            bottomDocsignPosition: "center end",
            bottomDocsignftcol: null,
            bottomDocsignimg: null,
            bottomDocsignrequired: null,
            bottomLines:[]
      },
      bgColor:     values.bgColor,
      bgimage:     null,
      imagewidth: values.imagewidth,
      bgposition:  null,
      ps: values.ps,
      orientation: values.orientation,
      tm: values.tm,
      bm: values.bm,
      lm: values.lm,
      rm: values.rm,
      bodylayout: values.bodylayout,
      temptype: values.temptype,
      labelColor: values.labelColor,
      fontColor: values.labelColor,
      fontSize: values.fontSize,
      fontfamily: values.fontfamily,
    };
     template.page_title.fields=JSON.parse(JSON.stringify(this.pageTitleList))
    for(let x of this.objectKeys(json.temp_title)){
      try{
      template.temp_title[x]=this.templateForm.controls[x].value
      }catch(Execption){}
    }
    template.temp_title.topHeaderLines=JSON.parse(JSON.stringify(this.topHeaderLines?.value.filter(x=> !!x.name)));
    for(let x of this.objectKeys(json.footer)){
      try{
        template.footer[x]=this.templateForm.controls[x].value
      }catch(Exception){}
    }
    template.footer.bottomLines=JSON.parse(JSON.stringify(this.FooterLines.value.filter(x=> !!x.name)));
    return template;
   }

   bodyEntermouse(type,i){
    this.itemvalue=this.itemvalue?.map((x,index)=>{
      x.displayeditor=index==i?true:false;
      x.displaytext=true;
      return {...x}
    })
   }
   downloadFile(){

    var pageTitle="ssss"
    var styles='';
    this.config.stylesheets.filter(x=>{
      styles=styles+`<link rel='stylesheet' href='${x.href}'> `;
    });
    var printContent=`
      <head>
      <title>${pageTitle}</title>
          ${styles}
      </head>
      <body>
        <div class="print-content">
          ${this.printcontent.nativeElement.innerHTML}
        </div>
      </body> `;
     this.downloadHtml=printContent;

    html2canvas(this.downloadpdf.nativeElement).then(canvas => {
      // Few necessary setting options
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL("image/png");
      let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF
      var position = 0;
      pdf.addImage(contentDataURL, "PNG", 0, position, imgWidth, imgHeight);
      pdf.save("MYPdf.pdf"); // Generated PDF
    });

   }

   sliceval(val,start,end){
    return val.slice(start,end);
   }

  replacelinetaxitems(string,inx){
    let index,taxableAmount,gstpercentage,cgst,sgst,igst,taxtotal;
    if(!!string && inx!=null){
      for (var k = 0; k <  this.taxdetails.length; k++) {
        if(inx==k){

          index=k+1;
          taxableAmount=this.taxdetails[k].taxableAmount.toFixed(2),
          gstpercentage=this.taxdetails[k].gstpercentage.toFixed(2),
          cgst=this.taxdetails[k].cgst.toFixed(2),
          sgst=this.taxdetails[k].sgst.toFixed(2),
          igst=this.taxdetails[k].igst.toFixed(2),
          taxtotal=this.taxdetails[k].taxtotal.toFixed(2),

          string=string.replace((new RegExp("{id}", "g")),index)
            .replace((new RegExp("{taxableAmount}", "g")),taxableAmount)
            .replace((new RegExp("{gstpercentage}", "g")),gstpercentage)
            .replace((new RegExp("{cgst}", "g")),cgst)
            .replace((new RegExp("{sgst}", "g")),sgst)
            .replace((new RegExp("{igst}", "g")),igst)
            .replace((new RegExp("{taxtotal}", "g")),taxtotal)
            return string;
        }
      }
    }
   }

   replacepagenumber(string,inx){
    if(!!string){
            string=string.replace((new RegExp("{pagenumber}", "g")),this.pagenumber)
            return string;
      }
   }


   replacelineitems(string,inx){
    let index,medicinename,category,genericname,mrngaftevngngt,drugIntakeRoute,drugUsageArea,instructionadviceheading,originalinstructionsenglish,drugIntakeAdviceenglish,instructionsothers,intakeadviceothers;
    if(!!string && inx!=null){
      for (var k = 0; k <  this.prescriptiondata.length; k++) {
        if(inx==k){

          let frequency = ((this.prescriptiondata[k].mor==null || this.prescriptiondata[k].mor== 0) && (this.prescriptiondata[k].aft==null || this.prescriptiondata[k].aft==0) && (this.prescriptiondata[k].eve==null || this.prescriptiondata[k].eve==0) && (this.prescriptiondata[k].night==null||this.prescriptiondata[k].night==0))?this.prescriptiondata[k].frequency : '' ;
          if(this.prescriptiondata[k].mor!=null && this.prescriptiondata[k].aft!=null && this.prescriptiondata[k].eve==0 && this.prescriptiondata[k].night!=null){
            mrngaftevngngt=this.prescriptiondata[k].mor + '-' + this.prescriptiondata[k].aft + '-' + this.prescriptiondata[k].night;
          }
          else if(this.prescriptiondata[k].mor!=null && this.prescriptiondata[k].aft!=null && this.prescriptiondata[k].eve!=0 && this.prescriptiondata[k].night!=null){
            mrngaftevngngt=this.prescriptiondata[k].mor + '-' + this.prescriptiondata[k].aft + '-' + this.prescriptiondata[k].eve + '-' + this.prescriptiondata[k].night;
          }
          else if(this.prescriptiondata[k].mor==null && this.prescriptiondata[k].aft==null && this.prescriptiondata[k].eve==null && this.prescriptiondata[k].night==null){
            mrngaftevngngt=this.prescriptiondata[k].frequency==null?"Every Once":this.prescriptiondata[k].frequency;
          }


          if(!!this.prescriptiondata[k].instructions && this.prescriptiondata[k].instructions!=undefined && !this.prescriptiondata[k].drugIntakeAdvice){
            instructionadviceheading="Instructions:";
            originalinstructionsenglish=this.prescriptiondata[k].originalinstructions!=null?this.prescriptiondata[k].originalinstructions:'';
            drugIntakeAdviceenglish='';
            instructionsothers=this.prescriptiondata[k].instructions;
            intakeadviceothers='';
          }
          else if(!!this.prescriptiondata[k].drugIntakeAdvice && this.prescriptiondata[k].drugIntakeAdvice!=undefined && !this.prescriptiondata[k].instructions){
            instructionadviceheading="Advice:";
            originalinstructionsenglish='';
            drugIntakeAdviceenglish=this.prescriptiondata[k].drugIntakeAdvice!=null?this.prescriptiondata[k].drugIntakeAdvice:'';
            instructionsothers='';
            intakeadviceothers=this.prescriptiondata[k].intakeadvice;
          }
          else if(!!this.prescriptiondata[k].drugIntakeAdvice && this.prescriptiondata[k].drugIntakeAdvice!=undefined && !!this.prescriptiondata[k].instructions && this.prescriptiondata[k].instructions!=undefined){
            instructionadviceheading="Instructions/Advice:";
            originalinstructionsenglish=this.prescriptiondata[k].originalinstructions!=null?this.prescriptiondata[k].originalinstructions:'';
            drugIntakeAdviceenglish=this.prescriptiondata[k].drugIntakeAdvice!=null?'/' + this.prescriptiondata[k].drugIntakeAdvice:'';
            instructionsothers=this.prescriptiondata[k].instructions;
            intakeadviceothers='/' + this.prescriptiondata[k].intakeadvice;
          }
          else if(!this.prescriptiondata[k].instructions || this.prescriptiondata[k].instructions==undefined || !this.prescriptiondata[k].drugIntakeAdvice || this.prescriptiondata[k].drugIntakeAdvice==undefined){
            instructionadviceheading='';
            originalinstructionsenglish='';
            drugIntakeAdviceenglish='';
            instructionsothers='';
            intakeadviceothers='';
          }
          var takenatothers;
          if(this.prescriptiondata[k].takenAt==this.prescriptiondata[k].takenAtinotherlang){
            takenatothers='';
          }
          else{
            takenatothers=this.prescriptiondata[k].takenAtinotherlang!=null?this.prescriptiondata[k].takenAtinotherlang:'';
          }

          index=k+1;

          if(this.from && this.from == 'fromIp'){
            medicinename=this.prescriptiondata[k].medicine?.name.toUpperCase(),
            category=this.sliceval(this.prescriptiondata[k].medicine?.medicineCategory?.name,0,3).toUpperCase(),
            genericname=this.prescriptiondata[k].medicine?.genericName?.name.toUpperCase()
          }
          else{
              medicinename=this.prescriptiondata[k].outsideMedicineFlag?this.prescriptiondata[k].medicineName.toUpperCase()+' - Outside Medicine':this.prescriptiondata[k].medicineName.toUpperCase(),
              category=this.sliceval(this.prescriptiondata[k].medicineCategoryName,0,3).toUpperCase(),
              genericname=this.prescriptiondata[k].genericname.toUpperCase()
          }
          drugIntakeRoute=this.prescriptiondata[k].drugIntakeRoute!=null?this.prescriptiondata[k].drugIntakeRoute:'-',
          drugUsageArea=this.prescriptiondata[k].drugUsageArea!=null?this.prescriptiondata[k].drugUsageArea:'-',


          string=string.replace((new RegExp("{id}", "g")),index)
            .replace((new RegExp("{medicineName}", "g")),medicinename)
            .replace((new RegExp("{medicineCategoryName}", "g")),category)
            .replace((new RegExp("{genericname}", "g")),genericname)
            .replace((new RegExp("{mrngaftevngngt}", "g")),mrngaftevngngt || '')
            .replace((new RegExp("{takenAtenglish}", "g")),this.prescriptiondata[k].takenAt!=null?this.prescriptiondata[k].takenAt:'')
            .replace((new RegExp("{takenAtothers}", "g")),takenatothers)
            .replace((new RegExp("{duration}", "g")),this.prescriptiondata[k].duration != 0 && this.prescriptiondata[k].duration != null ? this.prescriptiondata[k].duration : '')
            .replace((new RegExp("{durationUnit}", "g")),this.prescriptiondata[k].durationUnit !=null?this.prescriptiondata[k].durationUnit:'')
            .replace((new RegExp("{qty}", "g")),this.prescriptiondata[k].qty)
            .replace((new RegExp("{drugIntakeRoute}", "g")),drugIntakeRoute)
            .replace((new RegExp("{drugUsageArea}", "g")),drugUsageArea)
            .replace((new RegExp("{instructionadviceheading}", "g")),instructionadviceheading)
            .replace((new RegExp("{originalinstructionsenglish}", "g")),originalinstructionsenglish)
            .replace((new RegExp("{drugIntakeAdviceenglish}", "g")),drugIntakeAdviceenglish)
            .replace((new RegExp("{instructionsothers}", "g")),instructionsothers)
            .replace((new RegExp("{intakeadviceothers}", "g")),intakeadviceothers)
            .replace((new RegExp("{dosage}", "g")),this.prescriptiondata[k].dosage!=null?this.prescriptiondata[k].dosage:'-')
            .replace((new RegExp("{dosageUnit}", "g")),this.prescriptiondata[k].dosageunit!=null?this.prescriptiondata[k].dosageunit:'-')
           .replace((new RegExp("{mor}", "g")),this.prescriptiondata[k].mor || '')
           .replace((new RegExp("{aft}", "g")),this.prescriptiondata[k].aft || '')
           .replace((new RegExp("{eve}", "g")),this.prescriptiondata[k].eve || '')
           .replace((new RegExp("{night}", "g")),this.prescriptiondata[k].night || '')         
           .replace((new RegExp("{frequency}", "g")), frequency || '')         
            return string;
        }
      }
    }
   }

   replaceVariableTostring(string){
    if(!!string){
    let patdata,patientId,patientRegDate,patientAddress2,patientfirstname,patientlastname,patientguardianName,patientMobileNo,patientStatus,patientDoorno,patientAddress1,paientCity,patientgender,paymentdetails;

    if(this.regDetails!=null){
      patientId=this.regDetails?.regNum;
      patientRegDate=this.dateobj.dateUtctoLocal(this.regDetails?.regDate,"DD-MM-YYYY");
      patientfirstname=this.regDetails?.firstname.toUpperCase();
      patientlastname=this.regDetails?.lastname?this.regDetails?.lastname?.toUpperCase():'';
      patientguardianName=this.regDetails?.parentOrGuardianName!=null?this.regDetails.parentOrGuardianName:"";
      patientMobileNo=this.regDetails?.mobile;
      patientStatus=this.regDetails?.status!=null?this.regDetails?.status:"OP";
      patientDoorno=this.regDetails?.doorno!=null?this.regDetails?.doorno:"";
      patientAddress1=this.regDetails?.address1!=null?this.regDetails?.address1:"";
      patientAddress2=this.regDetails?.address2!=null?this.regDetails?.address2:"";
      paientCity=this.regDetails?.city!=null?this.regDetails?.city:"";
      patientgender=this.regDetails?.gender.toUpperCase();
      this.patientName=patientfirstname + " " + patientlastname
      this.age=!!this.regDetails?this.getPatientAgeByDOB(this.regDetails.dob,this.regDetails.ageResult,this.regDetails.dobFlag):""
      this.address=patientDoorno + patientAddress1 + paientCity
      this.preDate=this.dateobj.dateUtctoLocal(this.prescriptiondata?.[0].createdDate,'DD-MM-YYYY')
    }
    const prescriptionDate = new Date(this.prescriptiondata[this.prescriptiondata.length - 1]?.prescribedDate || this.prescriptiondata[this.prescriptiondata.length - 1]?.createdDate);

    string=string.replace((new RegExp("{patientno}", "g")),patientId)
    .replace((new RegExp("{hospitalTokenNo}", "g")),this.token|| '-')
     .replace((new RegExp("{regDate}", "g")),patientRegDate)
     .replace((new RegExp("{patienttitle}", "g")),this.patienttitle)
     .replace((new RegExp("{patientname}", "g")),patientfirstname + " " + patientlastname)
     .replace((new RegExp("{patientguardian}", "g")),patientguardianName)
     .replace((new RegExp("{patientmno}", "g")),patientMobileNo)
     .replace((new RegExp("{patientyear}", "g")),!!this.regDetails?this.getPatientAgeByYear(this.regDetails.dob,this.regDetails.ageResult,this.regDetails.dobFlag):"" )
     .replace((new RegExp("{patientage}", "g")),!!this.regDetails?this.getPatientAgeByDOB(this.regDetails.dob,this.regDetails.ageResult,this.regDetails.dobFlag):"")
     .replace((new RegExp("{patientgender}", "g")),patientgender)
     .replace((new RegExp("{patientstatus}", "g")),patientStatus)
     .replace((new RegExp("{patientDoorno}", "g")),patientDoorno)
     .replace((new RegExp("{patientaddres1}", "g")),patientDoorno + patientAddress1 + paientCity)
     .replace((new RegExp("{patientaddres2}", "g")),patientAddress2)
     .replace((new RegExp("{patientcity}", "g")),paientCity)
     .replace((new RegExp("{prescriptionDate}", "g")),this.dateobj.dateUtctoLocal(prescriptionDate,'DD-MM-YYYY'))
     .replace((new RegExp("{admdocname}", "g")),"Dr " + this.visitDoctor)
     .replace((new RegExp("{admdocdept}", "g")),this.visitDoctorDept)
     .replace((new RegExp("{patientipno}", "g")),this.admissionNumber ? " / " + this.admissionNumber : '')


     .replace(new RegExp("{bedno}", "g"), this.bedNo || "-")
     .replace(new RegExp("{wardname}", "g"), this.wardName || "-")
     .replace(new RegExp("{admbedno}", "g"), '')
     .replace(new RegExp("{admwardname}", "g"), '')
     .replace(new RegExp("{roomno}", "g"), this.roomNo || "-")
     .replace(new RegExp("{admissionDate}", "g"), this.dateobj?.dateUtctoLocal(this.admissionDate, "DD-MM-YYYY HH:mm") || "-")
     .replace(new RegExp("{height}", "g"), this.vitalData?.height || "-")
     .replace(new RegExp("{weight}", "g"), this.vitalData?.weight || "-")
     .replace(new RegExp("{bmi}", "g"), this.BMI || "-")
     .replace(new RegExp("{printDate}", "g"), this.dateobj.dateUtctoLocal(new Date(),'DD-MM-YYYY'))
     .replace(new RegExp("{doctor}", "g"),this.prescribedBy + "/ " + this.prescribedByDept)
     .replace(new RegExp("{preparedBy}", "g"), this.preparedBy || '-')
 
    return string;
    }
   }
   onpreviewdialog(){
        this.onPreviewDialog=true;
   }
   getPatientTitle(title){
      return this.titleList?.find(x=>x?.value==title)?.title;
   }
   popoverclose(){
    if(this.popovers){
      this.popovers.forEach(popover => {
        popover.hide();
       });
   }
    this.popover.hide();
  }
  showPer:boolean=false;
  loadPer:number;
   
getMailData(event){
          let data1 = document.getElementById('templatePreview');
          this.pdfBlobSrvc.downloadPDFForHims(data1,this.regDetails?.firstname,this.regDetails?.id,this,this.psDetails,`_prescription_${this.pagevisitId}`,'prescription','prescription','Mail',event,'pdf','Prescription','email');
  }

  getWhatsappData(event){
      let data1 = document.getElementById('templatePreview');
      this.pdfBlobSrvc.downloadPDFForHims(data1,this.regDetails?.firstname,this.regDetails?.id,this,this.psDetails,`_prescription_${this.pagevisitId}`,'prescription','prescription','Mail',event,'pdf','Prescription','whatsapp');
  }
  getSmsData(event){
      let data1 = document.getElementById('templatePreview');
      this.pdfBlobSrvc.downloadPDFForHims(data1,this.regDetails?.firstname,this.regDetails?.id,this,this.psDetails,`_prescription_${this.pagevisitId}`,'prescription','prescription','Mail',event,'pdf','Prescription','sms');
  }

  saveReport(event){
    event.target.disabled = true;
    this.downloadPDF(event);
  }

   async downloadPDF(event) {
    let data1 = document.getElementById('templatePreview');

    const category=this.pageFrom=='OP_Prescription' ? 'Prescription' : 'IP_Prescription';
    const admissionId=this.pageFrom=='OP_Prescription' ? null : this.admissionId;

    this.loadPer = 30;
    this.showPer = true;
    this.buttonsDisabled = true;
    this.changeDetectorRef.detectChanges();
    await this.sleep(100);

    this.pdfBlobSrvc.downloadPDFsaveReportABHA(data1,this.visitId,category,this.regId,admissionId,null,this,event);
  }

  onDownloadError() {
    this.buttonsDisabled = false;
    this.showPer = false;
    this.changeDetectorRef.detectChanges();
  }

  

}

export function rgbToHex(r: number, g: number, b: number): string {
  if(!!r && !!g && !!b)
    return `#${[r, g, b].map(x => x.toString(16).padStart(2, "0")).join("")}`;
  else
    return '#333333'
}

